import { createContext, useContext, useEffect } from "react";
import mitt, { type Emitter, type Handler } from "mitt";

export type Events = {
    zoom_in: void;
    zoom_out: void;
};

export type GlobalBus = Emitter<Events>;

export const createGlobalBus = (): GlobalBus => {
    return mitt<Events>();
};

const defaultEmitter = createGlobalBus();

export const GlobalBusContext = createContext<GlobalBus>(defaultEmitter);

export const useGlobalBus = (): GlobalBus => useContext(GlobalBusContext);

export const useListenGlobalBus = <Key extends keyof Events>(
    type: Key,
    handler: Handler<Events[Key]>,
): void => {
    const globalBus = useContext(GlobalBusContext);

    useEffect(() => {
        globalBus.on(type, handler);

        return () => {
            globalBus.off(type, handler);
        };
    }, [globalBus, handler, type]);
};
